import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import {
  FaLock,
  FaCopy,
  FaFileInvoice,
  FaSignOutAlt,
  FaSyncAlt,
} from 'react-icons/fa';
import { useAuth } from '../../hooks/auth';
import { formatCurrencyBRL } from '../../utils/utils';
import { toastSuccess, toastInfo } from '../../toasts';
import logoGestor from '../../assets/logo_gestor_sem_fundo.png';
import * as S from './styles';

const formatData = (data) => (data ? data.split(' ')[0] : '-');

const Bloqueado = () => {
  const { bloqueio, boletos, signOut, refreshBloqueio } = useAuth();
  const [checking, setChecking] = useState(false);

  if (!bloqueio) {
    return <Redirect to="/" />;
  }

  const copiarPix = (codigo) => {
    if (!codigo) return;
    navigator.clipboard.writeText(codigo);
    toastSuccess('Código Pix copiado para a área de transferência');
  };

  const verificarNovamente = async () => {
    setChecking(true);
    try {
      const aindaBloqueado = await refreshBloqueio();
      if (aindaBloqueado) {
        toastInfo('Ainda há pendências em aberto para essa conta.');
      }
    } finally {
      setChecking(false);
    }
  };

  document.title = 'MenuCheff Gestor - Bloqueado';

  return (
    <S.PageWrapper>
      <S.Card>
        <S.LeftPanel>
          <S.DecorLayer>
            <S.PanelGlow />
          </S.DecorLayer>
          <S.BrandBlock>
            <S.LockBadge>
              <FaLock size={30} />
            </S.LockBadge>
            <S.BadgePill>Sistema bloqueado</S.BadgePill>
            <S.FormLogo src={logoGestor} alt="MenuCheff Gestor" />
            <S.BrandName>MenuCheff</S.BrandName>
            <S.Tagline>
              O acesso ao painel está temporariamente restrito por pendência
              financeira.
            </S.Tagline>
          </S.BrandBlock>
        </S.LeftPanel>

        <S.RightPanel>
          <S.RightHeader>
            <h1>Pagamento pendente</h1>
            <S.RightSubtitle>
              Regularize os boletos abaixo para liberar automaticamente o acesso
              ao sistema.
            </S.RightSubtitle>
          </S.RightHeader>

          <S.InfoCard>
            <p>
              <strong>Motivo:</strong>{' '}
              {bloqueio.MotivoBloqueio || 'Pendência financeira'}
            </p>
            {bloqueio.InformacaoContato && (
              <p>
                <strong>Contato:</strong> {bloqueio.InformacaoContato}
              </p>
            )}
            {bloqueio.DataBloqueio && (
              <p>
                <strong>Bloqueado em:</strong>{' '}
                {formatData(bloqueio.DataBloqueio)}
              </p>
            )}
          </S.InfoCard>

          <S.SectionTitle>Boletos pendentes</S.SectionTitle>

          <S.BoletosList>
            {!boletos?.length && (
              <S.EmptyBoletos>
                Nenhum boleto pendente encontrado.
              </S.EmptyBoletos>
            )}

            {boletos?.map((boleto) => (
              <S.BoletoCard key={boleto.AsaasId}>
                <S.BoletoInfo>
                  <p>Vencimento: {formatData(boleto.DataVencimento)}</p>
                  <p>Valor: {formatCurrencyBRL(boleto.Valor)}</p>
                  {!!boleto.Juros && (
                    <p>Juros: {formatCurrencyBRL(boleto.Juros)}</p>
                  )}
                  {!!boleto.Multa && (
                    <p>Multa: {formatCurrencyBRL(boleto.Multa)}</p>
                  )}
                  <p className="valor-total">
                    Total: {formatCurrencyBRL(boleto.ValorTotal)}
                  </p>
                  {boleto.CelcoinLinkPDF && (
                    <S.BoletoLink
                      href={boleto.CelcoinLinkPDF}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFileInvoice size={12} />
                      Visualizar boleto (PDF)
                    </S.BoletoLink>
                  )}
                </S.BoletoInfo>

                {boleto.CelcoinPixImagem ? (
                  <S.PixArea>
                    <img
                      src={`data:image/png;base64,${boleto.CelcoinPixImagem}`}
                      alt="QR Code Pix"
                    />
                    <S.PixCopyButton
                      onClick={() => copiarPix(boleto.CelcoinPixCopiaCola)}
                    >
                      <FaCopy size={12} />
                      Copiar Pix
                    </S.PixCopyButton>
                  </S.PixArea>
                ) : (
                  <S.EmptyBoletos>Pix indisponível.</S.EmptyBoletos>
                )}
              </S.BoletoCard>
            ))}
          </S.BoletosList>

          <S.FooterLinks>
            <button onClick={verificarNovamente} disabled={checking}>
              <FaSyncAlt size={13} />
              {checking ? 'Verificando...' : 'Já paguei, verificar novamente'}
            </button>
            <button onClick={signOut}>
              <FaSignOutAlt size={13} />
              Sair
            </button>
          </S.FooterLinks>
        </S.RightPanel>
      </S.Card>
    </S.PageWrapper>
  );
};

export default Bloqueado;
